import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  .expand-details-button {
    float: right;
    color: ${(props) => props.theme.colorPalette.text.primary};
    letter-spacing: ${(props) => props.theme.typography.letterSpacings.ls064};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    padding-right: 0;

    &:after {
      content: '';
      padding: 0px 8px;
      width: 10px;
      height: 10px;
      display: none;
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 0px 3px;
      }
    }

    &.my-bag-action:after {
      display: inline-flex;
    }
  }

  .expanded-details::after {
    background: transparent url('${(props) => getIconPath('up_arrow_toggle', props)}') no-repeat
      right center;

    @media ${(props) => props.theme.mediaQuery.medium} {
      background: transparent url('${(props) => getIconPath('up_arrow_icon', props)}') no-repeat
        right center;
    }
  }

  .collapsed-details::after {
    background: transparent url('${(props) => getIconPath('down_arrow_toggle', props)}') no-repeat
      right center;

    @media ${(props) => props.theme.mediaQuery.medium} {
      background: transparent url('${(props) => getIconPath('down_arrow_icon', props)}') no-repeat
        right center;
    }
  }

  .spc-title {
    text-transform: capitalize;
  }

  .accordion-div {
    box-sizing: border-box;
    overflow: hidden;
    height: auto;
  }

  .shipping-accordion.collapsed,
  .payment-accordion.collapsed,
  .shipping-accordion.expand,
  .payment-accordion.expand {
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    }
  }
  .shipping-accordion.collapsed,
  .shipping-accordion.expand {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    }
  }
  .payment-accordion.collapsed {
    overflow: revert;
    .tooltip-bubble::before {
      top: -30px;
    }
    .tooltip-bubble::after {
      top: -28px;
    }
    .tooltip-message {
      top: -18px;
      position: relative;
      max-height: 160px;
      overflow-y: scroll;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      .tooltip-bubble::after,
      .tooltip-bubble::before {
        left: 20%;
      }
    }
  }
`;
